
var app = angular.module('heligreen', [
    /*
     * Order is not important. Angular makes a
     * pass to register all of the modules listed
     * and then when app.dashboard tries to use app.data,
     * its components are available.
     */

    /*
     * Everybody has access to these.
     * We could place these under every feature area,
     * but this is easier to maintain.
     */ 
    'app.core',
    'app.widgets',

    /*
     * Feature areas
    */
   'app.layout',
   'app.login',
   'app.usuarios',
   'app.grupos',
   'app.permisos',
   'app.companias',
   'app.principal',
   'app.bloqueos',
   'app.moviles',
   'app.aeronaves',
   'app.pilotos',
   'app.choferes',
   'app.empresasFumigadoras',
   'app.clientes',
   'app.proyectos',
   'app.servicios',
   'app.contratos',
   'app.parametros',
   'app.ordenes',
   'app.centrosCosto',
   'app.reportes'
]);